export default __webpack_public_path__ + "static/media/zoom_out.bfde7039.svg";